<template>
  <div class="containerRole">
    <select v-model="selectedValue" class="dark-select" @change="handleChange">
      <option v-for="(item, index) in items" :key="index" :value="item.label">
        {{ $t(`web_role_${item.label}`, `${item.label}`) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'ChangeRole',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    admin: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedValue: this.value,
    };
  },

  methods: {
    handleChange() {
      this.$emit('role-changed', {
        selectedValue: this.selectedValue,
        admin: this.admin,
      });
    },
  },
};
</script>

<style lang="scss">
.containerRole {
  width: 100%;

  background-color: transparent; /* Dark background for the container */
  border-radius: 5px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.dark-select {
  background-color: #2e2e2e; /* Dark background for the select */
  color: #ffffff; /* White text color for better readability */
  border: 1px solid #444444; /* Slightly lighter border */
  padding: 3px;
  cursor: pointer;
  border-radius: 5px;
  color: var(--ph-primary-text);
  font-size: 0.875rem;
  font-weight: bold;
}

.dark-select option {
  background-color: #2e2e2e; /* Dark background for options */
  color: #ffffff; /* White text color for options */
  cursor: pointer;
  color: var(--ph-primary-text);
  font-size: 0.875rem;
  font-weight: bold;
}
</style>
